<script setup lang="ts">
import type { LinkItem } from '../types'

interface Props {
  item: LinkItem
}

defineProps<Props>()
</script>

<template>
  <a
    v-if="item.url"
    :href="item.url"
    target="_blank"
    rel="noopener noreferrer"
    class="tool-card block p-4 bg-card rounded-lg shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 border border-border min-h-[70px] flex flex-col justify-center"
  >
    <h3 class="text-lg font-medium text-card-foreground mb-1">{{ item.title }}</h3>
    <p class="text-sm text-muted-foreground">{{ item.desc }}</p>
  </a>
  <div
    v-else
    class="tool-card block p-4 bg-card rounded-lg shadow-sm border border-border min-h-[70px] flex flex-col justify-center"
  >
    <h3 class="text-lg font-medium text-card-foreground mb-1">{{ item.title }}</h3>
    <p class="text-sm text-muted-foreground">{{ item.desc }}</p>
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .tool-card {
    min-height: 60px;
  }
}
</style>
